import type { RoomType } from '../../../domain/game/types';
import type { NpcDef } from '../../npcs/npcs';
import { eliteEnemyRoomContent, normalEnemyRoomContent } from './enemyRooms';
import {
  emptyRoomContent,
  npcRoomContent,
  secretRoomContent,
  trapRoomContent,
  treasureRoomContent,
} from './eventRooms';
import { bossRoomContent, safeRoomContent, teleporterRoomContent } from './specialRooms';
import type { ProceduralRoomContent } from './types';

export interface ProceduralRoomVariants {
  npc?: NpcDef;
}

export function proceduralRoomContent(
  type: RoomType,
  floor: number,
  variants: ProceduralRoomVariants = {},
): ProceduralRoomContent {
  switch (type) {
    case 'SAFE':
      return safeRoomContent(floor);
    case 'BOSS':
      return bossRoomContent(floor);
    case 'TELEPORTER':
      return teleporterRoomContent(floor);
    case 'ELITE_ENEMY':
      return eliteEnemyRoomContent(floor);
    case 'TREASURE':
      return treasureRoomContent(floor);
    case 'NPC':
      if (!variants.npc) {
        throw new Error('NPC room requires an NPC content definition');
      }
      return npcRoomContent(variants.npc);
    case 'TRAP':
      return trapRoomContent(floor);
    case 'SECRET':
      return secretRoomContent(floor);
    case 'EMPTY':
      return emptyRoomContent(floor);
    default:
      return normalEnemyRoomContent(floor);
  }
}
